export default "dist/wasmDbscan.wasm";